import Rule from "../../../common/rule";
import FootballState from "../../state/football-state";

export default class Timeout extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return fragment.associatedState === FootballState.Timeout;
    }
    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { team, time } = fragment;
        const { milliseconds } = time;
        gameContext.setClockSeconds(milliseconds / 1000);
        const currentPeriod = gameContext.getCurrentPeriod();
        gameContext.addTimeout(team.id, currentPeriod);
    }
}
